var _excluded = ["theme"];
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
var xsmallStyles = css(["padding:", ";", ";"], function (_ref) {
  var _ref$noPadding = _ref.noPadding,
    noPadding = _ref$noPadding === void 0 ? false : _ref$noPadding,
    _ref$$inline = _ref.$inline,
    $inline = _ref$$inline === void 0 ? false : _ref$$inline;
  return noPadding || $inline ? '0' : '6px 12px';
}, getFont(-2, 'compact'));
var smallStyles = css(["padding:", ";", ";"], function (_ref2) {
  var _ref2$noPadding = _ref2.noPadding,
    noPadding = _ref2$noPadding === void 0 ? false : _ref2$noPadding,
    _ref2$$inline = _ref2.$inline,
    $inline = _ref2$$inline === void 0 ? false : _ref2$$inline;
  return noPadding || $inline ? '0' : '6px 12px';
}, getFont(-1, 'compact'));
var mediumStyles = css(["padding:", ";", ";"], function (_ref3) {
  var _ref3$noPadding = _ref3.noPadding,
    noPadding = _ref3$noPadding === void 0 ? false : _ref3$noPadding,
    _ref3$$inline = _ref3.$inline,
    $inline = _ref3$$inline === void 0 ? false : _ref3$$inline;
  return noPadding || $inline ? '0' : '6px 18px';
}, getFont(0));
var defaultStyles = css(["padding:", ";", ";"], function (_ref4) {
  var _ref4$noPadding = _ref4.noPadding,
    noPadding = _ref4$noPadding === void 0 ? false : _ref4$noPadding,
    _ref4$$inline = _ref4.$inline,
    $inline = _ref4$$inline === void 0 ? false : _ref4$$inline;
  return noPadding || $inline ? '0' : '9px 24px';
}, getFont(0));
var largeStyles = css(["padding:", ";", ";"], function (_ref5) {
  var _ref5$noPadding = _ref5.noPadding,
    noPadding = _ref5$noPadding === void 0 ? false : _ref5$noPadding,
    _ref5$$inline = _ref5.$inline,
    $inline = _ref5$$inline === void 0 ? false : _ref5$$inline;
  return noPadding || $inline ? '0' : '12px 30px';
}, getFont(1));
var disabledStyles = css(["opacity:0.5;cursor:not-allowed;&:hover{opacity:0.5;}"]);
var getButtonStyles = function getButtonStyles(variant) {
  switch (variant) {
    case 'xsmall':
      return xsmallStyles;
    case 'small':
      return smallStyles;
    case 'medium':
      return mediumStyles;
    case 'large':
      return largeStyles;
    default:
      return defaultStyles;
  }
};
var COLORS = {
  primary: ['primary'],
  terciary: ['terciary'],
  secondary: ['secondary'],
  success: ['positive'],
  danger: ['negative']
};
var getColorStyles = function getColorStyles(_ref6) {
  var theme = _ref6.theme,
    props = _objectWithoutProperties(_ref6, _excluded);
  var foundColor = Object.keys(COLORS).find(function (item) {
    return props.hasOwnProperty(item);
  });
  if (!foundColor) {
    return css([""]);
  }
  var _COLORS$foundColor = _slicedToArray(COLORS[foundColor], 1),
    colorIndex = _COLORS$foundColor[0];
  return css(["color:", ";"], theme.colors[colorIndex]);
};
export var TextButton = styled.button.attrs(function (props) {
  return {
    $inline: props.inline,
    inline: undefined
  };
}).withConfig({
  displayName: "TextButton",
  componentId: "sc-g4cwu8-0"
})(["display:inline-flex;cursor:pointer;font-family:", ";font-weight:600;line-height:20px;", ";", ";", " &:hover{opacity:0.85;}svg{align-self:center;margin-left:3px;vertical-align:middle;}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.bodyFontFamily;
}, function (_ref8) {
  var variant = _ref8.variant;
  return getButtonStyles(variant);
}, function (props) {
  return getColorStyles(props);
}, function (_ref9) {
  var _ref9$disabled = _ref9.disabled,
    disabled = _ref9$disabled === void 0 ? false : _ref9$disabled;
  return disabled && disabledStyles;
});